module.exports = __webpack_public_path__ + "static/media/sh-hl.babf9923.svg";